/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMicroscope = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h8v6.106a7.366 7.366 0 0 1 3.736 1.815l2.092-2.093-1.414-1.414L17.828 5l4.243 4.243-1.414 1.414-1.414-1.414-2.23 2.229A6.77 6.77 0 0 1 18 15c0 1.971-.838 3.736-2.179 5H22v2H2v-2h8.74c2.945 0 5.26-2.278 5.26-5 0-2.32-1.68-4.316-4-4.856V15H4zm2 2v9h4V4z" />
        <path d="M4 18h8v-2H4z" />
      </g>
    </g>
  </Icon>
);
export { SvgMicroscope as Microscope };
